export const footer = (currentPage, pageCount) => {
  return [
    {
      text: "Páginas: " + currentPage + " / " + pageCount,
      fontSize: 8,
      margin: [20, 10, 0, 0],
    },
  ];
};
